import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import CataloguePage from "./pages/CataloguePage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CustomUniformsPage from "./pages/CustomUniformsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import TeamsPage from "./pages/TeamsPage";
import TeamPage from "./pages/TeamPage";
import MacronPage from "./pages/MacronPage";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-[#0D0D0D]">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/catalogue" element={<CataloguePage />} />
              <Route path="/product/:slug" element={<ProductDetailPage />} />
              <Route path="/custom-uniforms" element={<CustomUniformsPage />} />
              <Route path="/clubs" element={<TeamsPage />} />
              <Route path="/clubs/:slug" element={<TeamPage />} />
              <Route path="/macron" element={<MacronPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster 
            position="top-right" 
            toastOptions={{
              style: {
                background: '#0D0D0D',
                border: '1px solid #CE2B37',
                color: '#FAFAFA',
              },
            }}
          />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
